module.exports = __webpack_public_path__ + "media/images/athletes/3330-eab5e246b465f534e82cd40dd820e72d.png";